export const premiumMap: Record<string, Record<string, Record<string, number>>> = {
	"High Deductible Health Plan": {
		monthly: {
			EE: 100,
			ES: 150,
			EC: 200,
			ED: 250
		},
		biweekly: {
			EE: 25,
			ES: 200,
			EC: 150,
			ED: 250
		}
	},
	"Copay Health Plan": {
		monthly: {
			EE: 150,
			ES: 200,
			EC: 250,
			ED: 300
		},
		biweekly: {
			EE: 50,
			ES: 300,
			EC: 250,
			ED: 350
		}
	}
};

export const premiumDentalMap: Record<string, Record<string, number>> = {
	monthly: {
		EE: 26.0,
		ES: 67.0,
		EC: 50.5,
		ED: 99.5
	},
	biweekly: {
		EE: 26.0,
		ES: 67.0,
		EC: 50.5,
		ED: 99.5
	}
};

export const premiumVisonMap: Record<string, Record<string, number>> = {
	monthly: {
		EE: 7.7,
		ES: 12.58,
		EC: 12.32,
		ED: 20.27
	},
	biweekly: {
		EE: 7.7,
		ES: 12.58,
		EC: 12.32,
		ED: 20.27
	}
};
